
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useForm } from 'react-hook-form';
import { UserRole } from '@/types/userRole';

interface InviteUserDialogProps {
  open: boolean;
  onClose: () => void;
  onInvite: (data: { email: string; role: string; name: string }) => void;
}

const InviteUserDialog = ({ open, onClose, onInvite }: InviteUserDialogProps) => {
  const { register, handleSubmit, setValue, reset } = useForm();

  const onSubmit = (data: any) => {
    onInvite(data);
    reset();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Invite User</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div className="space-y-2">
            <label>Name</label>
            <Input {...register('name')} placeholder="Enter name" />
          </div>
          <div className="space-y-2">
            <label>Email</label>
            <Input {...register('email')} type="email" placeholder="Enter email" />
          </div>
          <div className="space-y-2">
            <label>Role</label>
            <Select onValueChange={(value) => setValue('role', value)}>
              <SelectTrigger>
                <SelectValue placeholder="Select role" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="user">User</SelectItem>
                <SelectItem value="manager">Manager</SelectItem>
                <SelectItem value="admin">Admin</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit">
              Send Invitation
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default InviteUserDialog;
